import Api from "meta/features/api";
import VirtualPath from "meta/utils/virtualPath";
const rootBaseUrl = `${VirtualPath}/webapi/root/`;
const userPreferenceUrl = `${VirtualPath}/webapi/userPreferences/`;
const api = Api({ baseURL: rootBaseUrl });
const userPreferenceApi = Api({ baseURL: userPreferenceUrl });
export default {
    validate: (password) => api.post(`validate`, { password }),
    getFdbLicenseStatus: () => api.get(`getFdbLicenseStatus`),
    checkFdbLicenseTemporaryPassword: (password) => api.post(`checkFdbLicenseTemporaryPassword`, { password }),
    setPatientId: (visID, frameSession) => api.post(`setPatientId?frameSession=${frameSession}`, { visID }),
    checkCoSign: () => api.get("hasAnyCosign"),
    resetUserLogin: () => api.get("resetUserLogin"),
    endFrameSession: (frameSession) => api.post(`/endFrameSession?frameSession=${frameSession}`),
    getSecuriryRightsFromMenuId: (menuId) => api.get("securityRightsForMenuId?menuId=" + menuId),
    updateHeartBeat: () => api.post("updateHeartBeat"),
    setBarcodeState: (frameSession, scanned) => api.post(`setBarcodeState?frameSession=${frameSession}&scanned=${scanned}`),
    setDockedTabWidth: (key, width) => userPreferenceApi.post("setDockedTabWidth", {
        TabUniqueId: key,
        Width: width,
    }),
    getSystemMessages: () => api.get("systemMessages"),
};
